import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import store from '~/store'
import router from '~/router'
import { i18n } from '~/plugins'
import App from '~/components/App'
import '~/components'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import {makeValidRules} from './common/index'




Vue.use(Vuetify,{
    iconfont: 'md'
})
Vue.use(VueToast, {
  // One of options
  position: 'top'
});

Vue.mixin({
  computed: {
    validRules() {
      const settings = this.$store.getters['settings/SETTINGS'] || {}
      const cMax = (settings.school && settings.school.class_score) || 50
      const eMax = (settings.school && settings.school.exam_score) || 50
      return makeValidRules({ cMax, eMax })
    }
  }
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'GHS',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});


Vue.config.productionTip = false

new Vue({
    el: '#app',
    i18n,
    store,
    router,
    ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js